<template>
<div>
  <Nav :navTitle="navTitle" :leftText="leftText" :rightText="rightText" :leftArrow="leftArrow" />
  <div class="content">
    <van-form @submit="onSubmit">
      <van-cell-group inset>
      <van-field v-model="username" name="username" input-align="right" required  placeholder="用户名" :rules="[{ required: true, message: '请填写用户名' }]" >
        <template #label>
          <span class="input-left-label-hq">用户名</span>
        </template>
      </van-field>
      <van-field v-model="mobile" type="tel" name="mobile" input-align="right" required placeholder="手机号码" :rules="[{ required: true, message: '请填写手机号码' }]" >
        <template #label>
          <span class="input-left-label-hq">手机号码</span>
        </template>
      </van-field>

      </van-cell-group>

      <div class="submit-box">
        <van-button round block type="info" native-type="submit" class="add-user">
          保存
        </van-button>
      </div>

    </van-form>
  </div>


</div>
</template>

<script>
import api from "@/fetch/api"
import Nav from "../Public/navTpl.vue"
import {
  Dialog,
  Toast
} from 'vant'

export default {
  metaInfo: {
    title: '用户信息',
  },
  components: {
    Nav,
  },
  data() {
    return {
      username: '',
      mobile: '',
      openid:'',
      navTitle: document.title,
      leftText: "返回",
      rightText: "首页",
      leftArrow: false,
      activeName: 'all',
      vehicleState: '01'
    };
  },
  created: function() {
    document.title = '用户信息';
    var that = this;
    var mobile = that.$store.state.wx_info.mobile ? that.$store.state.wx_info.mobile : "";
    var openid = that.$store.state.wx_info.openid ? that.$store.state.wx_info.openid : "";
    var username = that.$store.state.wx_info.username ? that.$store.state.wx_info.username : "";
    that.$data.username = username;
    that.$data.mobile = mobile;
    that.$data.openid = openid;


  },
  methods: {
    onSubmit(values) {
      const that = this;
      var username = values.username;
      var mobile = values.mobile;
      var openid = that.$store.state.wx_info.openid ? that.$store.state.wx_info.openid : "";
      if (openid == "") {
        //
      }

      const realnameReg = /[^\u4e00-\u9fa5a-zA-Z0-9\w]/g;
      if (realnameReg.test(username)) {
        Toast.fail('姓名格式有误，请重填');
        return false;
      }

      if (!(/^1[3456789]\d{9}$/.test(mobile))) {
        Toast.fail('手机号码有误，请重填');
        return false;
      }
      if (!that.$store.state.wx_info.mobile ) {
        api.addUserInfo(openid, username, mobile).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$store.commit('set_username', username);
            that.$store.commit('set_mobile', mobile);
            Dialog.alert({
              message: '注册成功',
            }).then(() => {
              that.$router.push({
                name: 'index'
              })
            });
          } else if (res.respCode < 0) {
            Dialog.alert({
              message: res.message,
            }).then(() => {
               // on confirm
            });
          } else {
            Toast.fail('连接异常');
          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
      } else {
        api.updateUserInfo(openid, username, mobile).then(function(resData) {
          var res = JSON.parse(resData);
          if (res.respCode == 0) {
            that.$store.commit('set_username', username);
            that.$store.commit('set_mobile', mobile);
            that.$store.commit('set_vehicleState', "02");
            Dialog.alert({
              message: '修改成功',
            }).then(() => {
              that.$router.push({
                name: 'index'
              })
            });
          } else if (res.respCode < 0) {
            Dialog.alert({
              message: res.message,
            }).then(() => {
              that.$router.push({
                name: 'index'
              })
            });
          } else {
            Toast.fail('连接异常');
          }
        }).catch(function(err) {
          console.log(err);
          Toast.fail('连接失败，请刷新页面');
        });
      }

    }
  },
}
</script>

<style lang="scss" scoped>
.content {
    margin-top: 4.75rem;
}

.submit-box{
  margin: 1rem;
}
</style>
